
import changeOpacityDomUtil from 'utils/dom/change-opacity'

const MAX_RETRIES = 3
const RETRY_DELAY = 500

/**
 * Attempts to reload an image with retries when loading fails
 * @param {string} imageUrl - Original image URL
 */
const retryImageLoadUtil = async (
  imageUrl
) => {
  const element = document.querySelector(`img[src="${imageUrl}"]`)

  if (element) {
    changeOpacityDomUtil({ element, opacity: 0 })
  }

  for (let i = 0; i < MAX_RETRIES; i++) {
    const reloadUrl = `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}retry=${Date.now()}`
    const imgElement = document.querySelector(`img[src="${imageUrl}"]`)

    if (imgElement) {
      const loadPromise = new Promise((resolve, reject) => {
        imgElement.onload = () => {
          changeOpacityDomUtil({ element, opacity: 1 })
          resolve(true)
        }
        imgElement.onerror = () => reject(new Error())
      })

      try {
        imgElement.src = reloadUrl
        await loadPromise
        return true
      } catch {
        continue
      }
    }

    await new Promise(resolve => setTimeout(resolve, RETRY_DELAY))
  }

  return false
}

export default retryImageLoadUtil
